import React, { FC } from "react";
import ToggleGroup from "@src/deprecatedDesignSystem/components/ToggleGroup";
import useTrainingResourceViewModeQueryParams, {
  TRAINING_RESOURCE_VIEW_MODE_OPTIONS,
} from "../hooks/useTrainingResourceViewModeQueryParams";
import { cn } from "@src/ui/lib/utils";
import { MODAL_Z_INDEX } from "@src/deprecatedDesignSystem/components/Modal";

const TOGGLE_VIEW_Z_INDEX = MODAL_Z_INDEX + 50;

const TrainingResourceToggleView: FC = () => {
  const { trainingResourceViewMode, setTrainingResourceViewMode } =
    useTrainingResourceViewModeQueryParams();

  return (
    <div
      className={cn(
        `flex justify-center items-center gap-2 p-1 rounded-full bg-gray-6 absolute bottom-6 right-6 shadow-lg`,
        `z-[${TOGGLE_VIEW_Z_INDEX}]`,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <ToggleGroup
        variant="icon"
        defaultValue="build"
        options={TRAINING_RESOURCE_VIEW_MODE_OPTIONS}
        value={trainingResourceViewMode || "document-view"}
        onValueChange={(value) => setTrainingResourceViewMode(value)}
      />
    </div>
  );
};

export default TrainingResourceToggleView;
